export const COLLECTION_FAIXAS_DNIT_ASFALTO = "tblAsfaltoFaixasDnit";

export const FAIXAS_DNIT_ASFALTO = [
  { id: "A25", label: "A-25" },
  { id: "B19", label: "B-19" },
  { id: "C125", label: "C-12,5" },
  { id: "D95", label: "D-9,5" },
];

export const CONFIGURACAO_DNIT_ASFALTO_PADRAO = {
  normaReferencia: "DNIT 031/2024 – ES",
  vaziosMin: "3",
  vaziosMax: "5",
  rbvMin: "65",
  rbvMax: "75",
  estabilidadeMinima: "500",
  fluenciaMinima: "2",
  fluenciaMaxima: "4,5",
  filerAsfaltoMin: "0,6",
  filerAsfaltoMax: "1,6",
  resistenciaTracaoMinima: "0,65",
  danoUmidadeMinimo: "0,70",
  vam: {
    A25: { v3: "11", v4: "12", v5: "13" },
    B19: { v3: "12", v4: "13", v5: "14" },
    C125: { v3: "13", v4: "14", v5: "15" },
    D95: { v3: "14", v4: "15", v5: "16" },
  },
};

const linhas = [
  ['1 1/2"', "38,1", [100, 100], null, null, null, ""],
  ['1"', "25,4", [90, 100], [100, 100], null, null, "±7"],
  ['3/4"', "19,1", [75, 89], [90, 100], [100, 100], null, "±7"],
  ['1/2"', "12,7", [58, 78], [70, 89], [90, 100], [100, 100], "±7"],
  ['3/8"', "9,5", [48, 71], [55, 82], [73, 89], [90, 100], "±7"],
  ['1/4"', "6,3", [35, 61], [42, 70], [53, 78], [65, 89], "±7"],
  ["Nº 4", "4,8", [29, 55], [35, 63], [44, 72], [53, 83], "±5"],
  ["Nº 8", "2,36", [19, 45], [23, 49], [28, 58], [32, 67], "±5"],
  ["Nº 16", "1,18", [13, 36], [16, 37], [17, 45], [20, 52], "±5"],
  ["Nº 30", "0,60", [9, 28], [10, 28], [11, 35], [13, 40], "±5"],
  ["Nº 50", "0,30", [5, 21], [6, 20], [6, 25], [8, 29], "±4"],
  ["Nº 100", "0,150", [2, 14], [4, 13], [3, 17], [4, 19], "±3"],
  ["Nº 200", "0,075", [1, 7], [2, 8], [2, 10], [2, 10], "±2"],
];

function faixa(valores) {
  return valores ? { min: String(valores[0]), max: String(valores[1]) } : { min: "", max: "" };
}

export const faixasDnitAsfaltoPadrao = linhas.map(
  ([astm, abertura, A25, B19, C125, D95, tolerancia], ordem) => ({
    ordem,
    astm,
    abertura,
    A25: faixa(A25),
    B19: faixa(B19),
    C125: faixa(C125),
    D95: faixa(D95),
    tolerancia,
  })
);

const peneirasGranulometriaAsfalto = [
  ...faixasDnitAsfaltoPadrao,
  { ordem: faixasDnitAsfaltoPadrao.length, astm: "Fundo", abertura: "" },
];

export function criarGranulometriaAsfalto(granulometria = []) {
  return peneirasGranulometriaAsfalto.map((peneira, indice) => {
    const existente = granulometria.find((linha) => linha.astm === peneira.astm) || granulometria[indice] || {};
    return {
      astm: peneira.astm,
      abertura: peneira.abertura,
      massaA: existente.massaA || "",
      massaB: existente.massaB || "",
      retidaAcumuladaA: existente.retidaAcumuladaA || "",
      retidaAcumuladaB: existente.retidaAcumuladaB || "",
      passanteA: existente.passanteA || "",
      passanteB: existente.passanteB || "",
      passanteMedio: existente.passanteMedio || existente.passante || "",
    };
  });
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const texto = String(valor).trim();
  const convertido = Number(texto.includes(",") ? texto.replace(/\./g, "").replace(",", ".") : texto);
  return Number.isFinite(convertido) ? convertido : null;
}

function formatar(valor) {
  return valor === null ? "" : valor.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

export function recalcularGranulometriaAsfalto(granulometria = [], massaInicialA = "", massaInicialB = "") {
  const base = criarGranulometriaAsfalto(granulometria);
  const totalRetidoA = base.reduce((soma, linha) => soma + (numero(linha.massaA) || 0), 0);
  const totalRetidoB = base.reduce((soma, linha) => soma + (numero(linha.massaB) || 0), 0);
  const totalA = numero(massaInicialA);
  const totalB = numero(massaInicialB);
  const diferencaA = totalA ? ((totalA - totalRetidoA) / totalA) * 100 : null;
  const diferencaB = totalB ? ((totalB - totalRetidoB) / totalB) * 100 : null;
  let acumuladaA = 0;
  let acumuladaB = 0;

  const linhasCalculadas = base.map((linha) => {
    const massaA = numero(linha.massaA);
    const massaB = numero(linha.massaB);
    if (massaA !== null && totalA) acumuladaA += (massaA / totalA) * 100;
    if (massaB !== null && totalB) acumuladaB += (massaB / totalB) * 100;
    const passanteA = massaA !== null && totalA ? Math.max(0, 100 - acumuladaA) : null;
    const passanteB = massaB !== null && totalB ? Math.max(0, 100 - acumuladaB) : null;
    const validos = [passanteA, passanteB].filter((valor) => valor !== null);
    const media = validos.length ? validos.reduce((soma, valor) => soma + valor, 0) / validos.length : null;

    return {
      ...linha,
      retidaAcumuladaA: massaA !== null && totalA ? formatar(acumuladaA) : "",
      retidaAcumuladaB: massaB !== null && totalB ? formatar(acumuladaB) : "",
      passanteA: formatar(passanteA),
      passanteB: formatar(passanteB),
      passanteMedio: formatar(media),
    };
  });

  return {
    granulometria: linhasCalculadas,
    totalA,
    totalB,
    totalRetidoA,
    totalRetidoB,
    diferencaA,
    diferencaB,
  };
}
